const eduExp = [
	{
		title: 'B.S - Computer Science',
		academics: '3.85 GPA',
		name: 'Oregon State University',
		description:
			'Focus in Human Computer Interaction & UX Design. To compliment a focus in full stack engineering, mobile and cloud development.',
		activities: 'Student Researcher, Graduate Research Assistant',
		awards:
			'Engineering Honor Roll, Science Honor Roll, Microbiology Honor Roll',
		start: 'January 2015',
		end: 'September 2018'
	},
	{
		title: 'Associates Transfer',
		academics: '3.83 GPA',
		name: 'Portland Community College',
		description:
			'Bounced around majors coming out of high school, all the way from Nursing, to Paramedic school. Ended up being introduced to computers in an intro course.',
		activities: 'EMT-B Liscensed, Future-Connect Student',
		awards: "Pheonix Award, Honor Roll, Dean's list, Presidents list",
		start: 'September 2013',
		end: 'January 2015'
	}
];

export default eduExp;
